var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCreditcard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-creditcard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.469,
    height: 40.469,
    viewBox: "0 0 40.469 40.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M39.429,13.148,27.321,1.04a3.561,3.561,0,0,0-5.03,0L7.1,16.233H3.557A3.561,3.561,0,0,0,0,19.79V36.912a3.561,3.561,0,0,0,3.557,3.557H30.8a3.561,3.561,0,0,0,3.557-3.557V23.252l5.075-5.075a3.561,3.561,0,0,0,0-5.03ZM23.968,2.717a1.187,1.187,0,0,1,1.677,0l6.239,6.239-7.277,7.277H10.452Zm8.015,34.195A1.187,1.187,0,0,1,30.8,38.1H3.557a1.187,1.187,0,0,1-1.186-1.186V19.79A1.187,1.187,0,0,1,3.557,18.6H30.8a1.187,1.187,0,0,1,1.186,1.186Zm-.7-20.646a3.573,3.573,0,0,0-.482-.034H27.96l5.6-5.6,1.677,1.677Zm6.472.235-3.4,3.4V19.79a3.542,3.542,0,0,0-.892-2.352l3.452-3.452.838.838A1.187,1.187,0,0,1,37.752,16.5Z",
    transform: "translate(0 0)",
    fill: "#0176c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M60,406.574h4.412v2.371H60Z",
    transform: "translate(-55.257 -374.437)",
    fill: "#0176c0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M146.267,406.574h4.412v2.371h-4.412Z",
    transform: "translate(-134.705 -374.437)",
    fill: "#0176c0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M232.534,406.574h4.412v2.371h-4.412Z",
    transform: "translate(-214.154 -374.437)",
    fill: "#0176c0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M318.8,406.574h4.412v2.371H318.8Z",
    transform: "translate(-293.602 -374.437)",
    fill: "#0176c0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M68,280.766H60v7.114h8Zm-2.371,4.743H62.371v-2.371h3.262Z",
    transform: "translate(-55.257 -258.573)",
    fill: "#0176c0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCreditcard);
export default __webpack_public_path__ + "static/media/ic-creditcard.148b962d.svg";
export { ForwardRef as ReactComponent };